import React, { useEffect, useState } from 'react';
import { InputNumber } from 'antd';
import ElementPinTypeControl from '../ElementPinTypeControl';

import styles from './RelativePosition.module.css';
import globalStyles from '../../GlobalGraphicEditor.module.css';

export default (props) => {
  const [disabled, setDisabled] = useState(props.disabled);
  const [localOffsetX, setLocalOffsetX] = useState(props.offsetX ?? 0);
  const [localOffsetY, setLocalOffsetY] = useState(props.offsetY ?? 0);
  const [isFocusedX, setIsFocusedX] = useState(false);
  const [isFocusedY, setIsFocusedY] = useState(false);

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);

  useEffect(() => {
    if (!isFocusedX) {
      setLocalOffsetX(props.offsetX ?? 0);
    }
  }, [props.offsetX, isFocusedX]);

  useEffect(() => {
    if (!isFocusedY) {
      setLocalOffsetY(props.offsetY ?? 0);
    }
  }, [props.offsetY, isFocusedY]);

  const measureBlock = <div className={styles.measureBlock}>px</div>;
  const selected1 = props.value1;
  const selectedPosition = props.dataSource.find((t) => t.id === selected1);
  const selected2 = props.value2;

  const handleBlurX = () => {
    setIsFocusedX(false);
    const val =
      typeof localOffsetX === 'number' ? localOffsetX : parseInt(localOffsetX, 10);
    if (!isNaN(val)) {
      props.changeOffsetX(val);
    } else {
      setLocalOffsetX(props.offsetX ?? 0);
    }
  };

  const handleBlurY = () => {
    setIsFocusedY(false);
    const val =
      typeof localOffsetY === 'number' ? localOffsetY : parseInt(localOffsetY, 10);
    if (!isNaN(val)) {
      props.changeOffsetY(val);
    } else {
      setLocalOffsetY(props.offsetY ?? 0);
    }
  };

  return (
    <div className={styles.wrapper}>
      {disabled && <div className={styles.disabledStyles} />}
      <div className={styles.title}>
        {selectedPosition && !props.disabled
          ? `Relative position calculates from the ${selectedPosition.name} of the parent layer`
          : 'Select parent layer point to pin to and set desired offset if needed:'}
      </div>
      <div className={styles.positionsBlock}>
        <div className={styles.controlsBlock}>
          <div>
            <div className={styles.smallLabel}>pin to</div>
            <ElementPinTypeControl
              disabled={props.disabled}
              value={selected1}
              onChange={props.onPinToChange}
            />
          </div>
          <div>
            <div className={styles.smallLabel}>pin by</div>
            <ElementPinTypeControl
              disabled={props.disabled}
              value={selected2}
              onChange={props.onPinByChange}
            />
          </div>
        </div>
        <div>
          <div className={styles.inputsBlock}>
            <div className={styles.measureTitle}>X</div>
            <div>
              <InputNumber
                size="small"
                value={isFocusedX ? localOffsetX : (props.offsetX ?? 0)}
                onChange={(val) => {
                  setIsFocusedX(true);
                  setLocalOffsetX(val);
                }}
                onFocus={() => setIsFocusedX(true)}
                onBlur={handleBlurX}
                className={`${globalStyles.input} ${styles.input}`}
              />
            </div>
            {measureBlock}
          </div>
          <div className={styles.inputsBlock}>
            <div className={styles.measureTitle}>Y</div>
            <div>
              <InputNumber
                size="small"
                value={isFocusedY ? localOffsetY : (props.offsetY ?? 0)}
                onChange={(val) => {
                  setIsFocusedY(true);
                  setLocalOffsetY(val);
                }}
                onFocus={() => setIsFocusedY(true)}
                onBlur={handleBlurY}
                className={`${globalStyles.input} ${styles.input}`}
              />
            </div>
            {measureBlock}
          </div>
        </div>
      </div>
    </div>
  );
};
